import {Injectable} from '@angular/core';
import {AbstractHttpService} from './abstract-http-service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {catchError} from 'rxjs/operators';
import {MakeModel} from '../model/make.model';

@Injectable({
  providedIn: 'root'
})
export class VehicleService extends AbstractHttpService {

  options = {
    headers: this.acceptJsonHeaders,
    withCredentials: true
  };

  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  getAllMakes(active: boolean = true): Observable<MakeModel[]> {
    return this.httpClient.get<MakeModel[]>(
      `//${environment.autoDomain}:${environment.autoPort}/api/makes?active=${active}&order[name]=asc`,
      this.options
    ).pipe(
      catchError(this.handleError)
    );
  }

}
